module.exports = __webpack_public_path__ + "static/media/architecture.74a5bad9.png";